import {createGlobalStyle} from "styled-components"

export const lightTheme = {
  bodyBg: "white",
  headings: "black",
  text: "#818181",
  transitionTime: ".25s",
}
export const darkTheme = {
  bodyBg: "#141a2c",
  headings: "white",
  text: "#c1c1c1",
  transitionTime: ".25s",
}

export const GlobalStyles = createGlobalStyle`
 body {
  background: ${props => props.theme.body};
  color: ${props => props.theme.textColor};
  transition: .3s ease;
 }
 h2{
   color: ${props => props.theme.headingColor};
 }
`